<template>
   <v-card
      class="mx-auto"
      max-width="344"
      style="margin: 20px;"
   >
   
   <v-img
      v-if="activity.Image"
      :src="activity.Image"
      :key="activity.Image"
      height="200px"
      @click="show = !show"
    />
      <div
         v-if="isExternal && activity.CategoryID"
         style="padding: 5px 0;text-transform: uppercase;"
         :style="{ backgroundColor: activity.CategoryColor, color: getIsDark(activity.CategoryColor) ? '#FFFFFF' : '#000000' }"
      >
         <center style="letter-spacing: 1px;">
            {{getTranslation(activity.CategoryName, locale)}}
         </center>
      </div>

      <v-card-title
         @click="show = !show"
         :style="{ color: content.BookingActTitleColor }"
         style="word-break: break-word;"
      >
       {{ getTranslation(activity.Name, locale) }}
    </v-card-title>

    <!--v-card-subtitle
        @click="show = !show"
         :style="{ color: content.BookingActTitleColor }"
       style="padding: 0 15px;word-break: break-word;"
       >
       {{ subtitle ? getTranslation(subtitle, locale) : '' }}ddd
    </v-card-subtitle-->
    <div
      v-if="dtouchWorkspace === '35b4c51b-c3b2-4b6a-8f52-7e68244d72a7'"
      @click="show = !show"
      :style="{ color: content.BookingActTitleColor }"
      style="padding: 0 15px;word-break: break-word;"
    >
      {{ activity.CategoryName ? getTranslation(activity.CategoryName, locale) : '' }}
    </div>
    <div
      v-else
        @click="show = !show"
         :style="{ color: content.BookingActTitleColor }"
       style="padding: 0 15px;word-break: break-word;"
       >
      {{ subtitle ? getTranslation(subtitle, locale) : '' }}
    </div>

    <v-card-actions>
      <v-btn
        :color="content.BookingActWeekSecondaryColor"
        text
        @click="show = !show"
      >
         {{ $t(`booking.${activity.AllowReservations != 0 ? 'reservation' : 'info'}`, locale) }}
      </v-btn>

      <v-spacer/>

      <v-btn
         v-if="showDetails"
        icon
        @click="show = !show"
        :color="content.BookingActWeekSecondaryColor"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition v-if="showDetails">
      <div v-show="show">
        <v-divider/>
      <div style="padding: 10px 10px 0 10px;text-align: center;">
      <reservation-form 
         v-for="(item, index) of activity.Events"
         :key="index"
         :event="item"
         :locale="locale"
         :color="content.BookingActTimeColor"
         :timeLimit="activity.TimeLimit !== null"
          :allowReservationsEventStart="allowReservationsEventStart"
         small
      />
      </div>
         <v-card-text 
            v-if="activity.Description"
            :style="{ color: content.BookingActContentColor }"
         >
           <p style="font-size: 10px;font-weight: 300;line-height: 1.2;" v-html="getTranslation(activity.Description, locale)" />

           <place
              :placeID="activity.PlaceID"
              :forcePlace="activity.Place"
              :label="$t('booking.place', locale)"
              :locale="locale"
           />
           <place
              :placeID="activity.MeetingPointID"
              :label="$t('booking.meetingPoint', locale)"
              :locale="locale"
           />
            <custom-fields-info-data
               :activityID="activity.ID"
               :locale="locale"
               :color="content.BookingActTimeColor"
            />
          <activity-link v-if="activity && activity.Link" :link="activity.Link" :locale="locale" :color="content.BookingActTitleColor" />
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import tinycolor from 'tinycolor2'
import utils from '@/services/utils'
import ReservationForm from './ReservationForm'
import CustomFieldsInfoData from './CustomFieldsInfoData'
import Place from '../Place'
import ActivityLink from '../ActivityLink'
export default {
   components: {
      ReservationForm,
      Place,
      CustomFieldsInfoData,
      ActivityLink,
   },
   props: {
      activity: {
         type: Object,
         required: true,
      },
      locale: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      config: {
         type: Object,
         required: true,
      },
      autoExpand: {
         type: Boolean,
         default: false,
      },
   },
   data: () => ({
      show: false,
      description: null,
      subtitle: null,
      allowReservationsEventStart: false,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
      showDetails () {
         return true //this.getTranslation(this.activity.Description, this.locale).length > 0 || this.activity.PlaceID || this.activity.MeetingPointID 
      },
      dtouchIsTouchPublic () {
         return this.$store.state.app.dtouchIsTouchPublic
      },
      isTotem () {
        //return this.$route.path === '/totem'
        return this.$route.path === '/totem' || utils.isTotem()
      },
      isExternal () {
         //timein
         return window.location.hash.indexOf('#/external/activities') >= 0
      },
   },
   watch: {
      'activity.ID' () {
         this.handleGetActivity()
      },
   },
   mounted () {
      this.handleGetActivity()
      this.show = this.autoExpand
   },
   methods: {
      getIsDark (v) {
         return tinycolor(v).isLight() ? false : true
      },
      handleGetActivity () {
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/activities/${this.activity.ID}`
         axios.get(url)
            .then((response) => {
               if (!response || !response.data) return
               const aux = response.data.shift()
               this.subtitle = aux && aux.Subtitle ? JSON.parse(aux.Subtitle) : null
              this.allowReservationsEventStart = aux && aux.AllowReservationsEventStart ? true : false
            })
            .catch(error => {
               console.log('Error', error)
            })
      },
      getTranslation(v, locale) {
         return utils.getTranslation(v, locale)
      },
      getSubtitle (locale) {
         const aux = this.getTranslation(this.activity.Subtitle, locale)
         if (aux && aux.length > 0) return aux
         //else return this.getTranslation(this.category.Name, locale)
         return ''
      },
      convertTime (v) {
         return utils.convertTime(v)
      },
   },
}
</script>

